export enum AppStoreTag {
	User = 'User',
	Users = 'Users',
	UserDetail = 'UserDetail',
	MaintenanceTasks = 'MaintenanceTasks',
	Boat = 'Boat',
	BoatByUser = 'BoatByUser',
	BoatDetail = 'BoatDetail',
	Dashboard = 'Dashboard',
	Historical = 'Historical',
	RealTimeData = 'RealTimeData',
	RealTimeAlarms = 'RealTimeAlarms',
	RealTimeStatus = 'RealTimeStatus',
	Histogram = 'Histogram',
	Templates = 'Templates',
	Map = 'Map',
	AvailableUsers = 'AvailableUsers',
	Notifications = 'Notifications',
	TermsAndConditions = 'TermsAndConditions',
	PrivacyPolicy = 'PrivacyPolicy',
	Companies = 'Companies',
	OrganizationNodes = 'OrganizationNodes',
	OrganizationMembers = 'OrganizationMembers',
	OrganizationTree = 'OrganizationTree',
}
